function hideProductsWithSoldoutSize() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.has('filter.v.option.size')) {
    const sizes = urlParams.getAll('filter.v.option.size')

    $('.ProductItem').each(function(i){
      variantSoldout = false;
      variantAvailable = false;
      
      $(this).find('.ProductItem__Sizes a:not(.sold-out)').each(function(j){
        if (sizes.includes($(this).data('value'))) {
          variantAvailable = true;
        }
      });

      if (!variantAvailable) {
        $(this).find('.ProductItem__Sizes a.sold-out').each(function(j){
          if (sizes.includes($(this).data('value'))) {
            variantSoldout = true;
          }
        });
      }

      if (variantSoldout && !variantAvailable) $(this).parent().addClass('hide-me');
      else $(this).parent().removeClass('hide-me');
    });
  }
  else 
  {
    $('.ProductItem').parent().removeClass('hide-me');
  }
}

$(document).on("theme:loading:end", function(){
  hideProductsWithSoldoutSize();
});